import React, { useEffect, useRef, useState } from 'react'; //import React Component
import { cloudStore } from '../firebase';
import { collection, getDocs, query, where } from 'firebase/firestore';

export function WelcomeContent() {
    useEffect(() => {
        const applyStyles = () => {
            const welcomeBoard = document.querySelector(".welcomeBoard");
            if (welcomeBoard) {
                if ('ontouchstart' in document.documentElement) {
                    welcomeBoard.style.width = "calc(100vw)";
                } else {
                    welcomeBoard.style.width = "calc(100vw - 15px)";
                }
            }
        };
        applyStyles();
    }, []);

    const [data, setdata] = useState([])
    useEffect(() => {
        if (data.length === 0) {
            getDocs(query(collection(cloudStore, "welcomeBoard"), where("Post_Content", "!=", null)))
                .then((querySnapshot) => {
                    const newInfoArray = querySnapshot.docs.map(doc => doc.data());
                    newInfoArray.sort((a, b) => b["Post_Content"]["date"] - a["Post_Content"]["date"]);
                    setdata(newInfoArray);
                })
        }
    }, [])

    const [ifClick, setifClick] = useState(false)
    const expandInfo = (e) => {
        let value = e.target.dataset.value;
        value = e.target.dataset.value.replace('.', '\\.');
        // let choose = document.querySelector(`#${value}`);
        let choose = document.querySelector(`#A${value}`);
        if (!ifClick) {
            choose.style.display = "block"
            setifClick(true)
        } else {
            choose.style.display = "none"
            setifClick(false)
        }
    }

    const addEachRefy = useRef('')
    const [slideWidth, setwidth] = useState(1300)
    const welcomeBoard = document.querySelector(".welcomeBoard")
    const slides = document.querySelector(".slides")
    const slide = document.querySelector(".slide")
    const [isDragging, setisDragging] = useState("false")
    const [mousecurrentPositionX, setX] = useState(0)
    const [touchcurrentPositionX, setX2] = useState(0)
    const [mouse, setmouse] = useState(0)
    const [switchPage, setswitchpage] = useState(false)
    const [switchPage2, setswitchpage2] = useState(false)
    const [keepPage, setkeepPage] = useState(false)
    const [keepPage2, setkeepPage2] = useState(false)
    const [click, setclick] = useState(false)
    const mouseDown = (e) => {
        setclick(true)
        setisDragging("true")
        setX(e.nativeEvent.offsetX - slides.offsetLeft);
        setmouse(e.nativeEvent.clientX)
        welcomeBoard.style.cursor = "grabbing"
        if (slide) {
            setwidth(slide.offsetWidth)
        }
        if (e.touches) {
            const initialTouch = e.touches[0];
            setX2(initialTouch.clientX - slides.offsetLeft)
            setmouse(initialTouch.clientX)
        }
    }

    const mouseMove = (e) => {
        if (mousecurrentPositionX !== 0 && isDragging === "true") {
            welcomeBoard.style.cursor = "grabbing"
            slides.style.left = `${e.nativeEvent.offsetX - mousecurrentPositionX}px`;
            let currentLeft = slides.offsetLeft
            if (currentLeft > 0) {
                slides.style.left = 0
            } else if (currentLeft < -(slideWidth * (data.length - 1))) {
                slides.style.left = `${-(slideWidth * (data.length - 1))}px`
            }
            let distance = mouse - e.nativeEvent.clientX
            if (distance > 0) { //左滑 mouse正
                if (distance > 300) {
                    setswitchpage(true)
                    setkeepPage(false)
                } else if (distance <= 300 && distance >= 0) {
                    setkeepPage(true)
                    setswitchpage(false)
                }
            } else { //右滑 mouse负
                if (distance < -300) {
                    setswitchpage2(true)
                    setkeepPage2(false)
                }
                else if (distance > -300 && distance < 0) {
                    setkeepPage2(true)
                    setswitchpage2(false)
                }
            }
        }
        if (touchcurrentPositionX !== 0 && isDragging === "true") {
            const initialTouch = e.touches[0];
            slides.style.left = `${initialTouch.clientX - touchcurrentPositionX}px`;
            let currentLeft = slides.offsetLeft
            if (currentLeft > 0) {
                slides.style.left = 0
            } else if (currentLeft < -(slideWidth * (data.length - 1))) {
                slides.style.left = `${-(slideWidth * (data.length - 1))}px`
            }
            let distance = mouse - initialTouch.clientX
            // console.log(distance)
            if (distance > 0) { //左滑 mouse正
                if (distance > 150) {
                    setswitchpage(true)
                    setkeepPage(false)
                } else if (distance <= 150 && distance >= 0) {
                    setkeepPage(true)
                    setswitchpage(false)
                }
            } else { //右滑 mouse负
                if (distance < -150) {
                    setswitchpage2(true)
                    setkeepPage2(false)
                }
                else if (distance > -150 && distance < 0) {
                    setkeepPage2(true)
                    setswitchpage2(false)
                }
            }
        }
    }
    const mouseUp = () => {
        setclick(false)
        setisDragging("false")
        welcomeBoard.style.cursor = "grab"
        let currentLeft = slides.offsetLeft
        //左滑
        if (switchPage && currentLeft > -slideWidth) {
            slides.style.transition = "0.5s"
            slides.style.left = `${-(slideWidth)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
            setswitchpage(false)
        }
        if (switchPage && currentLeft > -slideWidth * 2 && currentLeft < -slideWidth) {
            slides.style.transition = "0.5s"
            slides.style.left = `${-(slideWidth * 2)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
            setswitchpage(false)
        }

        if (switchPage && currentLeft > -slideWidth * 3 && currentLeft < -slideWidth * 2) {
            slides.style.transition = "0.5s"
            slides.style.left = `${-(slideWidth * 3)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
            setswitchpage(false)
        }

        if (keepPage && currentLeft > -slideWidth) {
            slides.style.transition = "0.3s"
            slides.style.left = `${-(0)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
            setkeepPage(false)
        }
        if (keepPage && currentLeft > -slideWidth * 2 && currentLeft < -slideWidth) {
            slides.style.transition = "0.3s"
            slides.style.left = `${-(slideWidth * 1)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
            setkeepPage(false)
        }
        if (keepPage && currentLeft > -slideWidth * 3 && currentLeft < -slideWidth * 2) {
            slides.style.transition = "0.3s"
            slides.style.left = `${-(slideWidth * 2)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
            setkeepPage(false)
        }
        //右滑
        if (switchPage2 && currentLeft < -slideWidth * 2) {
            slides.style.transition = "0.5s"
            slides.style.left = `${-(slideWidth * 2)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
            setswitchpage2(false)
        }
        if (switchPage2 && currentLeft < -slideWidth && currentLeft > -slideWidth * 2) {
            slides.style.transition = "0.5s"
            slides.style.left = `${-(slideWidth * 1)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
            setswitchpage2(false)
        }
        if (switchPage2 && currentLeft < 0 && currentLeft > -slideWidth) {
            slides.style.transition = "0.5s"
            slides.style.left = `${-(0)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
            setswitchpage2(false)
        }

        if (keepPage2 && currentLeft < -slideWidth * 2) {
            slides.style.transition = "0.3s"
            slides.style.left = `${-(slideWidth * 3)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
            setswitchpage2(false)
        }
        if (keepPage2 && currentLeft < -slideWidth && currentLeft > -slideWidth * 2) {
            slides.style.transition = "0.3s"
            slides.style.left = `${-(slideWidth * 2)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
            setswitchpage2(false)
        }
        if (keepPage2 && currentLeft < 0 && currentLeft > -slideWidth) {
            slides.style.transition = "0.3s"
            slides.style.left = `${-(slideWidth)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
            setswitchpage2(false)
        }
    }
    const mouseLeave = () => {
        setclick(false)
        setisDragging("false")
        if (welcomeBoard) {
            welcomeBoard.style.cursor = "grab"
        }
    }

    if (data.length > 0) {
        const addEach = data.map((content, index) => {
            const orderNumber = index + 1;
            console.log(content.Post_Content.title)
            return (
                <div className='slide' key={content.Post_Content.title}>
                    <img src={content.Post_Content.pic} alt={content.Post_Content.title} />
                    <div className='welcomeWord'>
                        <h1>{content.Post_Content.title}</h1>
                        <h2 style={{ fontWeight: "lighter" }}>{content.Post_Content.intro}</h2>
                        <div className='button welcomeButton' onClick={(e) => expandInfo(e)} data-value={content.Post_Content.title}>查看详情</div>
                    </div>
                    <h2 className='showPage'>{orderNumber}</h2>
                    <div className="expandInfo_content" id={"A" + content.Post_Content.title}>
                        <span
                            className="material-symbols-outlined"
                            data-value={content.Post_Content.title}
                            onClick={(e) => expandInfo(e)}
                            style={{ cursor: "pointer", position: "sticky", top: "20px", marginBottom: "40px", pointerEvents: "all" }}>Close</span>
                        <h1 style={{ fontSize: "50px" }}>{content.Post_Content.title}</h1>
                        <div className="centered-text" style={{ display: "flex", justifyContent: "center" }}>
                            <h2 style={{ fontWeight: "lighter", textAlign: "left" }}>{content.Post_Content.detail}</h2>
                        </div>
                    </div>
                </div >
            )
        })
        addEachRefy.current = addEach
    }

    const switchright = () => {
        const slides = document.querySelector(".slides")
        const slide = document.querySelector(".slide")
        let slideWidth = slide.offsetWidth

        let currentLeft = slides.offsetLeft
        //左滑
        if (currentLeft >= 0) {
            slides.style.transition = "0.3s"
            slides.style.left = `${-(slideWidth)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
        }
        if (currentLeft >= -slideWidth && currentLeft < 0) {
            slides.style.transition = "0.3s"
            slides.style.left = `${-(slideWidth * 2)}px`
            setTimeout(() => {
                slides.style.transition = "none";
            }, 500);
        }
        if (data.length > 2) {
            if (currentLeft >= -slideWidth * 2 && currentLeft < -slideWidth) {
                slides.style.transition = "0.3s"
                slides.style.left = `${-(slideWidth * 3)}px`
                setTimeout(() => {
                    slides.style.transition = "none";
                }, 500);
            }
            if (currentLeft >= -slideWidth * 3 && currentLeft < -slideWidth * 2) {
                slides.style.transition = "0.3s"
                slides.style.left = `${-(0)}px`
                setTimeout(() => {
                    slides.style.transition = "none";
                }, 500);
            }
        } else {
            if (currentLeft >= -slideWidth && currentLeft < 0) {
                slides.style.transition = "0.3s"
                slides.style.left = `${-(0)}px`
                setTimeout(() => {
                    slides.style.transition = "none";
                }, 500);
            }
        }
    }

    useEffect(() => {
        const intervalId = setInterval(switchright, 5000);
        if (click) {
            clearInterval(intervalId);
        }
        return () => clearInterval(intervalId);
    }, [click]);

    return (
        <div className='welcomeBoard'
            onMouseDown={mouseDown}
            onMouseMove={(e) => mouseMove(e)}
            onMouseUp={mouseUp}
            onMouseLeave={mouseLeave}
            onTouchStart={mouseDown}
            onTouchMove={(e) => mouseMove(e)}
            onTouchEnd={mouseUp}
            onTouchCancel={mouseLeave}
        >
            <div className='slides'>
                {addEachRefy.current}
            </div>
        </div >
    );
}